import script from "./Preview.vue?vue&type=script&setup=true&lang=js"
export * from "./Preview.vue?vue&type=script&setup=true&lang=js"

import "./Preview.vue?vue&type=style&index=0&id=adec55ae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adec55ae"]])

export default __exports__